import { MuiComponentOverrides } from "."
import spacing from "theme/themeSpacing"

export const MuiAccordionSummaryOverrides: MuiComponentOverrides<'MuiAccordionSummary', 'MuiAccordionSummary'> = {
  styleOverrides: {
    root: {
      padding: `${spacing.sm} 0`,
      margin: `0`,
    },
    content: `margin: 0`
  }
}
